import StorageApi from "@/api/StorageApi";

// 프로필 이미지 업로드 헬퍼 — 리사이즈(용량 최소화) + 내용 해시 파일명 + R2 업로드.
//
// 파일명 규칙: `${kind}_profile_${hash}.png`  (kind = "user" | "pet")
//  - prefix(user_profile / pet_profile)로 프로필 종류 구분
//  - hash = 리사이즈된 PNG 내용의 SHA-256(앞 32자) → 이미지가 바뀌면 파일명도 바뀜
//    ⇒ 같은 이미지 재업로드는 멱등(동일 파일명), 다른 이미지는 새 파일명이라 CDN 캐시 스테일 회피.

const MAX_SIZE = 256; // 아바타 표시(56~88px, 레티나)에 충분한 한 변 최대 px

// 이미지를 maxSize 이내로 비율 유지 축소 → PNG Blob 반환 (canvas).
function resizeImageToPngBlob(file, maxSize = MAX_SIZE) {
  return new Promise((resolve, reject) => {
    const objectUrl = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(objectUrl);
      const longest = Math.max(img.width, img.height) || 1;
      const scale = Math.min(1, maxSize / longest);
      const w = Math.max(1, Math.round(img.width * scale));
      const h = Math.max(1, Math.round(img.height * scale));

      const canvas = document.createElement("canvas");
      canvas.width = w;
      canvas.height = h;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, w, h);

      canvas.toBlob((blob) => {
        if (blob) resolve(blob);
        else reject(new Error("E_RESIZE_FAILED"));
      }, "image/png");
    };
    img.onerror = () => {
      URL.revokeObjectURL(objectUrl);
      reject(new Error("E_IMAGE_LOAD_FAILED"));
    };
    img.src = objectUrl;
  });
}

// Blob 내용의 SHA-256 hex (앞 length자).
async function hashBlob(blob, length = 32) {
  const buf = await blob.arrayBuffer();
  const digest = await crypto.subtle.digest("SHA-256", buf);
  const hex = Array.from(new Uint8Array(digest))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
  return hex.slice(0, length);
}

// 프로필 이미지 업로드 → 공개 CDN url 반환.
//  kind: "user" | "pet"
export async function uploadProfileImage(file, kind) {
  if (!file) throw new Error("E_NO_FILE");
  if (kind !== "user" && kind !== "pet") throw new Error("E_INVALID_KIND");

  const blob = await resizeImageToPngBlob(file);
  const hash = await hashBlob(blob);
  const filename = `${kind}_profile_${hash}.png`;

  const { url } = await StorageApi.upload(blob, filename);
  return url;
}
